module.exports = __webpack_public_path__ + "media/stylesheets/images/icon/arrow_d-3304150a616873063e88713227a4c972.svg";